(function () {
  function initSellingPlanPicker() {
    document.querySelectorAll('.evolve-selling-plan').forEach(function (picker) {
      var cards = picker.querySelectorAll('.evolve-selling-plan__card');
      var hiddenInput = picker.querySelector('.evolve-selling-plan__input');
      var sellingPlanId = picker.dataset.sellingPlanId;

      // Sync active class to whichever radio is checked on load
      function syncActiveState() {
        cards.forEach(function (c) {
          var r = c.querySelector('.evolve-selling-plan__radio');
          if (r && r.checked) {
            c.classList.add('evolve-selling-plan__card--active');
          } else {
            c.classList.remove('evolve-selling-plan__card--active');
          }
        });
      }
      syncActiveState();

      // The sticky bar has its own product form; mirror the chosen plan into it so both
      // add-to-cart paths submit the same thing.
      function syncStickyForm(value) {
        var stickyForm = document.getElementById('product-form-sticky-atc-bar');
        if (!stickyForm) return;
        var input = stickyForm.querySelector('input[name="selling_plan"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          stickyForm.appendChild(input);
        }
        input.value = value;
        input.disabled = !value;
      }

      function applyPlanChoice() {
        var subscribe = picker.querySelector('.evolve-selling-plan__radio[value="subscribe"]');
        var value = subscribe && subscribe.checked ? sellingPlanId : '';
        hiddenInput.value = value;
        hiddenInput.disabled = !value;
        syncStickyForm(value);
      }
      applyPlanChoice();

      cards.forEach(function (card) {
        var radio = card.querySelector('.evolve-selling-plan__radio');

        radio.addEventListener('change', function () {
          syncActiveState();
          applyPlanChoice();
        });
      });

      // Re-price once Sleek has finished a variant change (its fetched section is the source
      // of truth). The theme publishes variantChange on FoxTheme.pubsub and mirrors it as a
      // document CustomEvent; use whichever is available.
      function onVariantChange(variant) {
        if (variant) updateSellingPlanPrices(picker, variant);
      }
      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
          onVariantChange(event && event.data && event.data.variant);
        });
      } else {
        document.addEventListener('variant:changed', function (event) {
          onVariantChange(event.detail && event.detail.variant);
        });
      }
    });
  }

  function updateSellingPlanPrices(picker, variant) {
    if (!variant) {
      // Fallback: read the JSON Sleek renders inside variant-selects
      var variantJson = document.querySelector('[data-selected-variant]');
      if (!variantJson) return;
      try {
        variant = JSON.parse(variantJson.textContent);
      } catch (e) {
        return;
      }
    }

    var sellingPlanId = picker.dataset.sellingPlanId;
    var servings = parseInt(picker.dataset.servings, 10) || 30;

    // Find the selling plan allocation for this variant
    var allocation = null;
    if (variant.selling_plan_allocations) {
      for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
        if (String(variant.selling_plan_allocations[i].selling_plan_id) === String(sellingPlanId)) {
          allocation = variant.selling_plan_allocations[i];
          break;
        }
      }
    }

    var variantPrice = variant.price;
    var subPrice = allocation ? allocation.per_delivery_price : variantPrice;

    // Update subscribe card prices
    var subCard = picker.querySelector('[data-plan-type="subscribe"]');
    if (subCard) {
      var priceEl = subCard.querySelector('.evolve-selling-plan__price');
      var compareEl = subCard.querySelector('.evolve-selling-plan__compare-price');
      var perServingEl = subCard.querySelector('.evolve-selling-plan__right-bottom .evolve-selling-plan__per-serving');

      if (priceEl) priceEl.textContent = formatMoney(subPrice);
      if (compareEl) {
        if (variantPrice !== subPrice) {
          compareEl.textContent = formatMoney(variantPrice);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (perServingEl) perServingEl.textContent = formatMoney(Math.round(subPrice / servings)) + ' per serving';

      // Update badge
      var badgeEl = subCard.querySelector('.evolve-selling-plan__badge');
      if (badgeEl && variantPrice > 0 && subPrice < variantPrice) {
        var pct = Math.round(((variantPrice - subPrice) / variantPrice) * 100);
        badgeEl.textContent = pct + '% Off';
        badgeEl.style.display = '';
      } else if (badgeEl) {
        badgeEl.style.display = 'none';
      }
    }

    // Update one-time card prices
    var onetimeCard = picker.querySelector('[data-plan-type="onetime"]');
    if (onetimeCard) {
      var onetimePriceEl = onetimeCard.querySelector('.evolve-selling-plan__price');
      var onetimePerServingEl = onetimeCard.querySelector('.evolve-selling-plan__right-bottom .evolve-selling-plan__per-serving');

      if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(variantPrice);
      if (onetimePerServingEl) onetimePerServingEl.textContent = formatMoney(Math.round(variantPrice / servings)) + ' per serving';
    }
  }

  function formatMoney(cents) {
    // Sleek's own formatter honours the shop money format (comma decimals, currency suffix)
    if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
      return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings && FoxTheme.settings.moneyFormat);
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format);
    }
    // Last resort: store currency (EUR), comma decimals as the shop format uses
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSellingPlanPicker);
  } else {
    initSellingPlanPicker();
  }
})();
